import NextLink from "next/link";
import React, { useContext } from "react";
import { NavContext } from "contexts";

import { colors, font } from "utils/styles";
import switchMegaNav from "./switchMegaNav";

import { Icon } from "@components/Icons";

export default function MobileNavigation(props) {
	return (
		<div className={`${props.className ? props.className : ""}  mobileNav `}>
			<div className="pt-4">
				<NavLink name="Career" text="Career & Learning" />
				<br />
				<NavLink name="Resources" text="Leadership Library" />
				<br />
				<NavLink name="Community" text="Membership & Community" />
				<br />
				<NavLink text="For Organizations" link="/aapl-solutions" />
				<br />
				<NavLink text="Store" name="Store" />
				<br />
				<NavLink name="About" text="About AAPL" />
			</div>
			<style jsx="true">{`
				.mobileNav {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: stretch;
					min-width: 75%;
					background-color: white;
				}
			`}</style>
		</div>
	);
}

const NavLink = ({ text, name, link }) => {
	const { setMegaNavName, megaNavName } = useContext(NavContext);

	const isSelected = name && name === megaNavName;

	return (
		<>
			<li onClick={() => (isSelected ? setMegaNavName("") : setMegaNavName(name))} className="nav-item">
				{link && (
					<NextLink href={link}>
						<span className="d-inline nav-link">{text}</span>
					</NextLink>
				)}
				{!link && <a className="d-inline nav-link me-2">{text}</a>}
				{name ? isSelected ? <Icon style={{}} icon="carrotUp" /> : <Icon style={{}} icon="carrotDown" /> : null}
			</li>

			{isSelected && switchMegaNav(megaNavName)}

			<style jsx="true">{`
				.nav-item {
					display: inline-block;
					white-space: nowrap;
					margin-bottom: 1em;
					cursor: pointer;
					position: relative;
				}
				.nav-link {
					display: block;
					width: 100%;
					color: ${colors.darkBlue} !important;
					font-weight: bold !important;
					font-family: ${font.default};
					line-height: 28px;
					font-size: 20px;
					white-space: nowrap;
				}
			`}</style>
		</>
	);
};
